export default __webpack_public_path__ + "static/media/TIP-Network---Logo_mono.26971d85.svg";